<template>
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Kassen-Tablets</h4>
        </div>
        <div class="card-body">
            <div class="alert alert-info" role="alert">
                <i class="fa fa-exclamation-triangle"></i> 
                  Tablets nur bei Fehlfunktion neustarten. Der Neustart wird verzögert am Gerät durchgeführt.
                </div>
          <div v-if="loading" class="text-center">
            <i class="fa fa-spinner fa-spin"></i> Laden...
          </div>
          <el-table v-else :data="devices" style="width: 100%">
            <el-table-column prop="name" label="Name"></el-table-column>
            <el-table-column label="" width="150" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="small" icon="el-icon-refresh" :disabled="isLocked(scope.row)" @click="confirmReboot(scope.row)">
                  {{ isLocked(scope.row) ? remainingTime(scope.row) : 'Neustarten' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import store from "../../../../store";
import { db, fc } from "../../../../firebaseDb";
import { httpsCallable } from "firebase/functions";
import { Table, TableColumn, Button, MessageBox } from "element-ui";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Button);

export default {
  data() {
    return {
      location: store.getters.userlocation,
      devices: [],
      loading: true,
      lockedDevices: {},
      now: Date.now(),
      timerInterval: null,
    };
  },
  created() {
    this.loadDevices();
    this.timerInterval = setInterval(() => {
      this.now = Date.now();
    }, 1000);
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadDevices();
      }
    );
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  },
  methods: {
    isLocked(device) {
      const lockedUntil = this.lockedDevices[device.deviceId];
      return lockedUntil && this.now < lockedUntil;
    },
    remainingTime(device) {
      const lockedUntil = this.lockedDevices[device.deviceId];
      if (!lockedUntil) return '';
      const diff = Math.max(0, Math.ceil((lockedUntil - this.now) / 1000));
      const min = Math.floor(diff / 60);
      const sec = diff % 60;
      return `${min}:${sec.toString().padStart(2, '0')}`;
    },
    loadDevices() {
      this.loading = true;
      db.collection("devices")
        .where("locationId", "==", this.location)
        .orderBy("name")
        .onSnapshot((snapshot) => {
          this.devices = [];
          snapshot.forEach((doc) => {
            this.devices.push({
              key: doc.id,
              name: doc.data().name,
              deviceId: doc.data().deviceId,
            });
          });
          this.loading = false;
        });
    },
    confirmReboot(device) {
      MessageBox.confirm(
        `Soll das Gerät "${device.name}" wirklich neugestartet werden?`,
        "Gerät neustarten",
        {
          confirmButtonText: "Neustarten",
          cancelButtonText: "Abbrechen",
          type: "warning",
        }
      )
        .then(() => {
          this.rebootDevice(device);
        })
        .catch(() => {});
    },
    rebootDevice(device) {
      const reboot = httpsCallable(fc, "scalefusion-rebootDevice");
      reboot({ deviceId: device.deviceId })
        .then(() => {
          this.$set(this.lockedDevices, device.deviceId, Date.now() + 10 * 60 * 1000);
          this.$notify({
            message: `"${device.name}" wird in Kürze neugestartet.`,
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
        })
        .catch((error) => {
          this.$notify({
            message: "Fehler beim Neustarten: " + error.message,
            icon: "fa fa-exclamation-triangle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
            showClose: true,
            timeout: 5000,
          });
        });
    },
  },
};
</script>
